import {api} from '../../../shared';
import {
  ProjectDocumentsFilter,
  ProjectDocumentsResponse,
  CreateProjectDocumentDTO,
  ProjectDocumentModel,
  UpdateProjectDocumentDTO,
  UpdateProjectDocumentFileDTO,
} from '../model';

export const projectDocumentsApi = {
  getProjectDocuments: async (params: ProjectDocumentsFilter = {}): Promise<ProjectDocumentsResponse> => {
    const {pageSize = 25, after, ...restParams} = params;
    const queryParams = {
      ...restParams,
      includeTotalCount: true,
      first: pageSize,
      ...(after && {after}),
    };

    const {data} = await api.get<ProjectDocumentsResponse>('/api/content/admin/project/documents', {params: queryParams});
    return data;
  },

  getProjectDocumentById: async (documentId: string): Promise<ProjectDocumentModel> => {
    const {data} = await api.get<ProjectDocumentModel>(`/api/content/admin/project/documents/${documentId}`);
    return data;
  },

  createProjectDocument: async (document: CreateProjectDocumentDTO): Promise<ProjectDocumentModel> => {
    const {data} = await api.post<ProjectDocumentModel>('/api/content/admin/project/documents', document);
    return data;
  },

  updateProjectDocument: async (documentId: string, document: UpdateProjectDocumentDTO): Promise<ProjectDocumentModel> => {
    const {data} = await api.post<ProjectDocumentModel>(`/api/content/admin/project/documents/${documentId}`, document);
    return data;
  },

  updateProjectDocumentFile: async (documentId: string, fileData: UpdateProjectDocumentFileDTO): Promise<void> => {
    await api.post(`/api/content/admin/project/documents/${documentId}/file`, fileData);
  },

  deleteProjectDocument: async (documentId: string): Promise<void> => {
    await api.delete(`/api/content/admin/project/documents/${documentId}`);
  },
};

